import en from './en.json'
import ta from './ta.json'
import { getTranslateLanguage } from '../lib/googleTranslate'

const TABLES = { en, ta }

const PHRASES = {
  Hello: 'nav.hello',
  'Teacher Portal': 'nav.teacherPortal',
  'Admin Portal': 'nav.adminPortal',
  'Super Admin Portal': 'nav.superAdminPortal',
  'Parent Portal': 'nav.parentPortal',
  'All classes': 'nav.allClasses',
  'All assigned classes': 'nav.allAssigned',
  'Whole school': 'nav.wholeSchool',
  'No class assigned': 'nav.noClass',
  'Switch class': 'nav.switchClass',
  'Active class': 'nav.activeClass',
  Notifications: 'nav.notifications',
  'Mark all read': 'nav.markAllRead',
  'No notifications.': 'nav.noNotifications',
  'Loading…': 'nav.loading',
  'View All Activity': 'nav.viewAll',
  'AI assistant': 'nav.aiAssistant',
  'AI Assistant': 'nav.aiAssistant',
  'Failed to load notifications': 'nav.failedNotifications',
  Logout: 'nav.logOut',
  Member: 'nav.member',
  Compass: 'nav.compass',
  New: 'nav.badgeNew',
  Management: 'nav.management',
  Analytics: 'nav.analytics',
  Staff: 'nav.staff',
  Approvals: 'nav.approvals',
  'Switch role': 'nav.switchRole',
  'Switch student': 'nav.switchStudent',
  Activity: 'nav.activity',
  Blueprints: 'nav.blueprints',
  'Performance Report': 'nav.performanceReport',
  'Blueprint standards': 'nav.blueprintStandards',
  'Blueprint Standards': 'nav.blueprintStandards',
  Teachers: 'nav.teachers',
  'Active staff': 'nav.activeStaff',
  'School roster': 'nav.schoolRoster',
  'Admins · counselors': 'nav.adminsCounselors',
  'Sign in': 'nav.signIn',
  'Signing in…': 'nav.signingIn',
  'Welcome back': 'nav.welcomeBack',
  Password: 'nav.password',
  'School code': 'nav.schoolCode',
  Email: 'nav.email',
  'Account type': 'nav.accountType',
  'Command center': 'dash.commandCenter',
  Teacher: 'dash.teacher',
  Admin: 'dash.admin',
  Students: 'dash.students',
  Classes: 'dash.classes',
  'Needs attention': 'dash.needsAttention',
  'Dashboard period': 'dash.period',
  Interventions: 'dash.interventions',
  InLog: 'dash.inlog',
  Reports: 'dash.reports',
  Manage: 'dash.manage',
  AI: 'dash.ai',
  'AI Chat': 'dash.aiChat',
  'AI Chatbot': 'dash.aiChatbot',
  Support: 'inlog.support',
  Messages: 'inlog.messages',
  Home: 'inlog.home',
  'Log out': 'inlog.logOut',
  'Quick log': 'inlog.quickLog',
  'Search students': 'inlog.searchStudents',
  'Search name or number': 'inlog.searchNameOrNumber',
  'Select a student to begin assessment': 'inlog.selectStudentBegin',
  'Feedback sent': 'inlog.feedbackSent',
  'Pending feedback': 'inlog.pendingFeedback',
  Completed: 'inlog.completed',
  Dashboard: 'parent.dashboard',
  Report: 'parent.reportNav',
  Events: 'parent.events',
  'Guardian account': 'parent.guardianAccount',
  'Student Portal': 'parent.studentPortal',
  'Guardian view': 'parent.guardianView',
  Live: 'parent.live',
  'At a glance': 'parent.atAGlance',
  'Snapshot for guardians': 'parent.snapshotForGuardians',
  'Holistic score': 'parent.holisticScore',
  'School-wide snapshot': 'parent.schoolWideSnapshot',
  'Learning signals': 'parent.learningSignals',
  'Focus dimensions tracked': 'parent.focusDimensionsTracked',
  'Class events': 'parent.classEvents',
  'On the calendar': 'parent.onTheCalendar',
  'None scheduled': 'parent.noneScheduled',
  'Linked children': 'parent.linkedChildren',
  'Single student view': 'parent.singleStudentView',
  'Open Messages': 'parent.openMessages',
  Class: 'parent.class',
  'View full report': 'parent.viewFullReport',
  'Class calendar': 'parent.classCalendar',
  'Upcoming events': 'parent.upcomingEvents',
  'Past events': 'parent.pastEvents',
  'All events': 'parent.allEvents',
  Past: 'parent.past',
  'Teacher messages': 'parent.teacherMessages',
  Update: 'parent.update',
  'Support update': 'parent.supportUpdate',
  Navigation: 'parent.navigation',
  'Where families go next': 'parent.whereFamiliesGo',
  'Progress report': 'parent.progressReport',
  'Parent assistant': 'parent.parentAssistant',
  'Account & roster': 'parent.accountAndRoster',
  'For parents': 'parent.forParents',
  'Privacy note': 'parent.privacyNote',
  'Ask the parent assistant': 'parent.askParentAssistant',
  Refresh: 'parent.refresh',
  Timeline: 'parent.timeline',
  'Approved teacher messages': 'parent.approvedTeacherMessages',
  'School reports': 'parent.schoolReports',
  Approved: 'parent.approved',
  Areas: 'parent.areas',
  'Learning dimensions': 'parent.learningDimensions',
  Thriving: 'parent.thriving',
  'On track': 'parent.onTrack',
  'At risk': 'parent.atRisk',
  'Academic reports': 'parent.academicReports',
  'Kindergarten readiness': 'parent.kindergartenReadiness',
  'Parent profile': 'parent.parentProfile',
  'Back to dashboard': 'parent.backToDashboard',
  'My profile': 'parent.myProfile',
  'All Activity': 'parent.allActivity',
  Week: 'dash.week',
  Month: 'dash.month',
  Year: 'dash.year',
  All: 'dash.all',
  'This week': 'dash.thisWeek',
  'This month': 'dash.thisMonth',
  'This year': 'dash.thisYear',
  'All recorded data': 'dash.allRecorded',
  'Class roster': 'dash.classRoster',
  'Intervention board': 'dash.interventionBoard',
  'Student Support Board': 'dash.studentSupportBoard',
  'Student 360': 'dash.student360',
  Marks: 'dash.marks',
  Settings: 'dash.settings',
  'Full schedule': 'dash.fullSchedule',
  Shortcuts: 'dash.shortcuts',
  'Jump to tools': 'dash.jumpToTools',
  Upcoming: 'dash.upcoming',
  Schedule: 'dash.schedule',
  'Quick classroom': 'dash.quickClassroom',
  Invisible: 'dash.invisible',
  'Not sent': 'dash.notSent',
  'Interventions for class': 'dash.interventionsForClass',
  'Interventions by class': 'dash.interventionsByClass',
  Board: 'dash.board',
  'Performance trend': 'dash.performanceTrend',
  'Monthly class average': 'dash.monthlyClassAvg',
  'Monthly school average': 'dash.monthlySchoolAvg',
  Subjects: 'dash.subjects',
  Attendance: 'dash.attendance',
  'Marks bands': 'dash.marksBands',
  Strong: 'dash.strong',
  Good: 'dash.good',
  Average: 'dash.average',
  'Needs lift': 'dash.needsLift',
  'below 50': 'dash.below50',
  scored: 'dash.scored',
  Strongest: 'dash.strongest',
  Spread: 'dash.spread',
  'Low day': 'dash.lowDay',
  Absences: 'dash.absences',
  'Below 80%': 'dash.below80',
  'Invisible students': 'dash.invisibleStudents',
  'Not sent messages': 'dash.notSentMessages',
  'View all': 'dash.viewAllShort',
  'Last 7 days': 'dash.last7',
  'Last 30 days': 'dash.last30',
  'Last 12 months': 'dash.last12',
  'All time': 'dash.allTime',
  'Loading events…': 'dash.loadingEvents',
  'No upcoming events for this class.': 'dash.noUpcoming',
  'No upcoming events on the calendar.': 'dash.noUpcomingCalendar',
  'Nothing in this list right now.': 'dash.nothingNow',
  'No invisible students for this period.': 'dash.noInvisiblePeriod',
  'Loading class pulse…': 'dash.loadingClassPulse',
  'Loading school pulse…': 'dash.loadingSchoolPulse',
  Never: 'dash.never',
  today: 'dash.today',
  '1 day ago': 'dash.oneDayAgo',
  'Staff · activity': 'dash.staffActivity',
  'Teacher pulse': 'dash.teacherPulse',
  'Most active': 'dash.mostActive',
  Plans: 'dash.plans',
  Merits: 'dash.meritsLabel',
  Directory: 'dash.directory',
  Leaderboard: 'dash.leaderboard',
  'No lead yet': 'dash.noLeadYet',
  'No recorded input': 'dash.noRecordedInput',
  'Check-ins': 'dash.checkIns',
  'Scroll sideways for every teacher': 'dash.scrollSidewaysTeachers',
  'Scroll sideways to see every class': 'dash.scrollSidewaysClasses',
  View: 'reports.tabView',
  'Generate report': 'reports.tabGenerate',
  'Grade journey': 'reports.tabGradeJourney',
  'Child Continuity': 'reports.tabChildContinuity',
  Setup: 'reports.setup',
  'Student roster': 'reports.studentRoster',
  Grade: 'reports.grade',
  Section: 'reports.section',
  Chat: 'inlog.tabChat',
  'Check-in': 'inlog.tabCheckIn',
  Summary: 'inlog.tabSummary',
  'Quick check-in': 'inlog.quickCheckIn',
  'Quick log whole class': 'inlog.quickLogWholeClass',
  'Marks & performance': 'inlog.marksPerformance',
  'Loading summary…': 'inlog.loadingSummary',
  'Generating summary…': 'inlog.generatingSummary',
  'Progress summary': 'inlog.progressSummary',
  'Generate summary': 'inlog.generateSummary',
  "Today’s session": 'inlog.todaysSession',
  'Student Support Center': 'support.title',
  'Plan, track, and act for student support.': 'support.subtitle',
  'Priority Queue': 'support.priorityQueue',
  'Timeline Reports': 'support.timelineReports',
  'New Support Plan': 'support.newSupportPlan',
  'By Student': 'support.byStudent',
  'By Intervention': 'support.byIntervention',
  'Loading priority queue…': 'support.loadingQueue',
  'Redirecting to Priority Queue…': 'support.redirectingQueue',
  'Back to Priority Queue': 'support.backToQueue',
  'High priority': 'support.highPriority',
  'Awaiting your review': 'support.awaitingReview',
  'Active interventions': 'support.activeInterventions',
  'Resolved (completed in this class)': 'support.resolvedCompleted',
  'All support areas': 'support.allSupportAreas',
  'All statuses': 'support.allStatuses',
  'Student, domain, or root cause…': 'support.studentDomainRoot',
  'Refresh queue': 'support.refreshQueue',
  Retry: 'support.retry',
  'AI SUGGESTED': 'support.aiSuggested',
  HIGH: 'support.high',
  'Sort: Priority': 'support.sortPriority',
  'Show everything': 'support.showEverything',
  'Teaching AI Assistant': 'aiChat.teachingAssistant',
  'ONLINE · GEMINI': 'aiChat.onlineGemini',
  'Start a new conversation': 'aiChat.startNew',
  'CLASS FILTER': 'aiChat.classFilter',
  'Class filter': 'aiChat.classFilter',
  'All classes (school-wide)': 'aiChat.allClassesSchool',
  'RECENT CHATS': 'aiChat.recentChats',
  'Recent chats': 'aiChat.recentChats',
  'Sessions & focus': 'aiChat.sessionsFocus',
  'Tailor answers to one learner': 'aiChat.tailorAnswers',
  'Loading roster…': 'aiChat.loadingRoster',
  'Loading students…': 'aiChat.loadingStudents',
  'Search students…': 'aiChat.searchStudents',
  'Parent update': 'aiChat.parentUpdate',
  'Compare with last term': 'aiChat.compareLastTerm',
  'Draft support plan': 'aiChat.draftSupportPlan',
  'Weekly summary': 'aiChat.weeklySummary',
  'Loading academic reports…': 'reports.loadingAcademicReports',
  'Try adjusting the search query.': 'reports.tryAdjustingSearch',
  'About this page': 'reports.aboutThisPage',
  'Brief for the next teacher': 'reports.briefNextTeacher',
  'Preview as next teacher': 'reports.previewAsNextTeacher',
  'Exit preview': 'reports.exitPreview',
  'Refresh from 360': 'reports.refreshFrom360',
  'Search a student by name': 'reports.searchStudentByName',
  'Pick a student to begin': 'reports.pickStudentBegin',
  'Select an option': 'reports.selectAnOption',
  'No students found': 'reports.noStudentsFound',
}

/** Prefer dictionary ids for labels that must never go through Google Translate. */
const LABEL_IDS = {
  'AI Chat': 'dash.aiChat',
  'AI Chatbot': 'dash.aiChatbot',
  'AI assistant': 'nav.aiAssistant',
  'AI Assistant': 'nav.aiAssistant',
  AI: 'dash.ai',
  InLog: 'dash.inlog',
  'Student Support Board': 'dash.studentSupportBoard',
  'Intervention board': 'dash.interventionBoard',
  Reports: 'dash.reports',
  Manage: 'dash.manage',
  Support: 'inlog.support',
  Messages: 'inlog.messages',
  Home: 'inlog.home',
  'Log out': 'inlog.logOut',
  Logout: 'nav.logOut',
  Compass: 'nav.compass',
  New: 'nav.badgeNew',
  Management: 'nav.management',
  Analytics: 'nav.analytics',
  Staff: 'nav.staff',
  Approvals: 'nav.approvals',
  'Switch role': 'nav.switchRole',
  'Switch student': 'nav.switchStudent',
  Blueprints: 'nav.blueprints',
  'Performance Report': 'nav.performanceReport',
  'Blueprint standards': 'nav.blueprintStandards',
  Teachers: 'nav.teachers',
  'Sign in': 'nav.signIn',
  Dashboard: 'parent.dashboard',
  Report: 'parent.reportNav',
  Events: 'parent.events',
  'Guardian account': 'parent.guardianAccount',
  'Student Portal': 'parent.studentPortal',
  'My profile': 'parent.myProfile',
  'All Activity': 'parent.allActivity',
  'Teacher pulse': 'dash.teacherPulse',
  Plans: 'dash.plans',
  Merits: 'dash.meritsLabel',
  'Check-ins': 'dash.checkIns',
  View: 'reports.tabView',
  'Generate report': 'reports.tabGenerate',
  'Grade journey': 'reports.tabGradeJourney',
  'Child Continuity': 'reports.tabChildContinuity',
  Chat: 'inlog.tabChat',
  'Check-in': 'inlog.tabCheckIn',
  Summary: 'inlog.tabSummary',
  'Student Support Center': 'support.title',
  'Priority Queue': 'support.priorityQueue',
  'Timeline Reports': 'support.timelineReports',
  'New Support Plan': 'support.newSupportPlan',
  'Teaching AI Assistant': 'aiChat.teachingAssistant',
}

export function chromeIdForLabel(label) {
  if (label == null || label === '') return null
  return LABEL_IDS[label] || null
}

function lookup(table, id) {
  return String(id)
    .split('.')
    .reduce((node, part) => (node && typeof node === 'object' ? node[part] : undefined), table)
}

export function getLocale() {
  return getTranslateLanguage() === 'ta' ? 'ta' : 'en'
}

/** JSON dictionary lookup. Unknown ids fall back to English, then the id itself.
 *  Templates may use {inlog}; it defaults to dash.inlog for the active locale. */
export function t(id, vars) {
  const locale = getLocale()
  const value = lookup(TABLES[locale], id) ?? lookup(TABLES.en, id) ?? id
  let text = String(value)
  const merged = { ...(vars || {}) }
  if (text.includes('{inlog}') && merged.inlog == null) {
    merged.inlog =
      lookup(TABLES[locale], 'dash.inlog') ??
      lookup(TABLES.en, 'dash.inlog') ??
      'InLog'
  }
  Object.entries(merged).forEach(([key, replacement]) => {
    text = text.replaceAll(`{${key}}`, String(replacement ?? ''))
  })
  return text
}

/**
 * Fixed UI copy. Returns the JSON translation when this English phrase is in the
 * dictionary, otherwise null so Google Translate can handle the dynamic text.
 */
export function translateChrome(english) {
  const id = PHRASES[english]
  if (!id) return null
  return t(id)
}
